<template>
  <div>
    <vertical>
      <page-header :items="headerItems" title="باشگاه مشتریان" />
      <div class="card">
        <Section title="هدیه خرید">
          <div>
            <BaseText
              required
              inputType="number"
              :maxlength="3"
              v-model="model.buyDadCoinPercentage"
              :errortext="errorText"
              :showError="submit && model.buyDadCoinPercentage.length === 0"
              title="درصد تراکنش اسکیل کوین"
              placeholder="درصد تراکنش اسکیل کوین"
            />
          </div>
        </Section>
      </div>

      <div class="card">
        <Section title="هدیه معرف">
          <BaseText
            required
            :errortext="errorText"
            :showError="submit && model.inviterPercentage.length === 0"
            inputType="number"
            :maxlength="3"
            v-model="model.inviterPercentage"
            title="درصد کیف پول تومانی دعوت کننده"
            placeholder="درصد کیف پول تومانی"
            class="my-3"
          />

          <BaseText
            required
            :errortext="errorText"
            :showError="submit && model.invitedPercentage.length === 0"
            inputType="number"
            :maxlength="3"
            v-model="model.invitedPercentage"
            title="درصد تخفیف دعوت شونده"
            placeholder="درصد تخفیف اولین خرید"
          />
        </Section>
      </div>

      <div class="card">
        <Section title="هدیه تولد">
          <BaseText
            required
            :errortext="errorText"
            :showError="submit && model.birthDateDadCoinPercentage.length === 0"
            :maxlength="200"
            v-model="model.birthDateDadCoinPercentage"
            title="مبلغ هدیه اسکیل کوین"
            placeholder="مبلغ هدیه اسکیل کوین"
          />
        </Section>
      </div>

      <div class="d-flex justify-content-between">
        <h6 style="color: rgba(85, 110, 230, 1); font-size: 16px; font-weight: 700; margin: 0">
          ادمین گرامی در صورت تغییر در درصد امتیازهای کاربران ، در خرید ها و تراکنش های آتی افراد اعمال میگردد و در تراکنش های قبلی کاربران تغییری اعمال نخواهد شد.
        </h6>

        <div class="d-flex gap-3">
          <b-button @click="onSubmit" variant="primary  px-5"> ثبت </b-button>
        </div>
      </div>
    </vertical>
    <toast :error="error" :showToast="showToast" :title="message"></toast>
  </div>
</template>

<script>
import BaseText from '../../../components/common/form/formModules/BaseText.vue'
import Section from '../../../components/common/form/Section.vue'
import Toast from '../../../components/common/Toast.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import Vertical from '../../../layouts/vertical.vue'
import skillUpCustomersClub from '../../../services/skillUp/customersClub'

export default {
  components: { Vertical, PageHeader, Section, BaseText, Toast },
  data() {
    return {
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'باشگاه مشتریان',
          active: true,
        },
      ],
      model: {
        buyDadCoinPercentage: null,
        birthDateDadCoinPercentage: null,
        inviterPercentage: null,
        invitedPercentage: null,
      },
      submit: false,
      showToast: false,
      message: '',
      error: false,
      errorText: 'وارد کردن این فیلد اجباری می باشد .',
    }
  },
  watch: {
    'model.buyDadCoinPercentage'(value) {
      if (value) this.model.buyDadCoinPercentage = Math.round(value)
    },
    'model.birthDateDadCoinPercentage'(value) {
      if (value) this.model.birthDateDadCoinPercentage = Math.round(value)
      this.model.birthDateDadCoinPercentage = this.model.birthDateDadCoinPercentage.toString()
      this.model.birthDateDadCoinPercentage = value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    'model.inviterPercentage'(value) {
      if (value) this.model.inviterPercentage = Math.round(value)
    },
    'model.invitedPercentage'(value) {
      if (value) this.model.invitedPercentage = Math.round(value)
    },
  },
  mounted() {
    this.fetchCustomersClub()
  },
  methods: {
    async fetchCustomersClub() {
      try {
        const req = await skillUpCustomersClub.fetchCustomersClub()
        this.model = req.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    async onSubmit() {
      let _birthDateDadCoinPercentage = this.model.birthDateDadCoinPercentage.replace(/,/g, '')
      this.submit = true
      if (
        this.model.birthDateDadCoinPercentage.length === 0 ||
        this.model.buyDadCoinPercentage.length === 0 ||
        this.model.invitedPercentage.length === 0 ||
        this.model.inviterPercentage.length === 0
      )
        return false

      try {
        const req = await skillUpCustomersClub.updateCustomerClub({ ...this.model, birthDateDadCoinPercentage: +_birthDateDadCoinPercentage })
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = false
          this.message = 'درخواست شما با موفقیت ثبت گردید.'
        })
        this.fetchCustomersClub()
      } catch (error) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.message = 'عملیات با خطا مواجه شد مجدد تلاش کنید.'
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .labelStyle {
  white-space: pre-wrap !important;
  max-width: none;
  min-width: 180px;
  margin-left: 0;
}
</style>
